var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guestAlert-popup"},[_c('div',{staticClass:"guestAlert-main"},[_c('div',{staticClass:"main-title"},[_vm._v("温馨提示")]),_c('div',{staticClass:"main-text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"main-confirm",on:{"click":_vm.closePopup}},[_vm._v("确定")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }